import { render, staticRenderFns } from "./newslist.vue?vue&type=template&id=0838c298&scoped=true&"
import script from "./newslist.vue?vue&type=script&lang=js&"
export * from "./newslist.vue?vue&type=script&lang=js&"
import style0 from "./newslist.vue?vue&type=style&index=0&id=0838c298&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0838c298",
  null
  
)

export default component.exports